import React from "react";
import { CopyIcon, KebabIcon, TrashIcon } from "./warmUpCardIcons";
import { FocusIcon } from "./oneListIcons";
import { KebabButton, Menu, MenuItem, Wrapper } from "./WarmUpGroupMenu";
import { useMenuButton } from "./useMenuButton";

// The quick card's kebab and its menu (Figma 6463:7838): the warm-up card
// menu's look, with Duplicate Group, Edit Group Focus and Archive Group.
export const QuickGroupMenu = ({
  buttonId,
  code,
  isOpen,
  onOpenChange,
  duplicating,
  onDuplicate,
  onEditGroupFocus,
  onArchive,
}) => {
  const items = [
    { label: duplicating ? "Duplicating…" : "Duplicate Group", Icon: CopyIcon, action: onDuplicate, disabled: duplicating },
    { label: "Edit Group Focus", Icon: FocusIcon, action: onEditGroupFocus },
    { label: "Archive Group", Icon: TrashIcon, action: onArchive },
  ];
  const menu = useMenuButton({ idPrefix: "quick-group-menu", itemCount: items.length, isOpen, onOpenChange });
  // The chosen row goes with the menu; focus goes back to the kebab, where
  // the dialog an item opens also returns it.
  const runFromKebab = (action) => () => {
    menu.buttonRef.current?.focus();
    action?.();
  };

  return (
    <Wrapper {...menu.wrapperProps}>
      <KebabButton {...menu.buttonProps} id={buttonId} aria-label={`Actions for quick group ${code}`}>
        <KebabIcon />
      </KebabButton>
      {menu.isOpen && (
        <Menu {...menu.menuProps} aria-label={`Quick group ${code}`}>
          {items.map(({ label, Icon, action, disabled }, index) => (
            <MenuItem
              key={label}
              {...menu.itemProps(index, disabled ? undefined : runFromKebab(action))}
              aria-disabled={disabled ? "true" : undefined}
            >
              <Icon />
              {label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Wrapper>
  );
};
